export default {
  PUSH_MY_TRAINING_PROGRAM_TRAINING_PHASES: 'PUSH_MY_TRAINING_PROGRAM_TRAINING_PHASES',
  SET_MY_TRAINING_PROGRAM_OIT: 'SET_MY_TRAINING_PROGRAM_OIT',
  SET_MY_TRAINING_PROGRAM_IS_LOADING: 'SET_MY_TRAINING_PROGRAM_IS_LOADING',
};
